import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { PetForm } from "@/components/PetForm";
import { api, errMsg } from "@/lib/api";

export default function PetEdit() {
  const { id } = useParams();
  const nav = useNavigate();
  const [pet, setPet] = useState(id ? null : {});
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (id) api.get(`/pets/${id}`).then((r) => setPet(r.data)); }, [id]);

  const save = async (f, file) => {
    setSaving(true);
    try {
      const keys = ["name", "species", "breed", "birthday", "weight", "microchip", "allergies", "conditions", "medications_note", "food", "quirks", "vet_name", "vet_phone"];
      const body = Object.fromEntries(keys.map((k) => [k, f[k] || null]));
      body.name = f.name;
      body.species = f.species || "dog";
      const { data } = id ? await api.put(`/pets/${id}`, body) : await api.post("/pets", body);
      if (file) {
        const fd = new FormData();
        fd.append("file", file);
        await api.post(`/pets/${data.id}/photo`, fd);
      }
      toast.success(`${data.name} saved`);
      nav(`/app/pets/${data.id}`);
    } catch (err) { toast.error(errMsg(err)); }
    setSaving(false);
  };

  if (!pet) return <div className="pl-card h-60 animate-pulse" />;
  return (
    <div data-testid="pet-edit-page">
      <h1 className="font-heading text-4xl font-extrabold mb-5">{id ? `Edit ${pet.name}` : "Add a pet"}</h1>
      <div className="pl-card p-5"><PetForm initial={pet} onSubmit={save} saving={saving} /></div>
    </div>
  );
}
